import useAdvancedSearch from '../../../hooks/use-advanced-search'
import useUser from '../../../hooks/use-user'
import { isAdminUser } from '../../../services/user-utils'
import { AdvancedSearchTable } from '../../../components/aoraki/generic-search-react/src'
import { Button, Card, ContentContainer, HeadingRow, LoadingIndicator, useTitleChange } from '@msaf/core-react'
import { DISPLAY_DATE_FORMAT } from '@msaf/core-common'

export default function AdminUsers() {
  useTitleChange('Administration | Users')
  const { user } = useUser()

  const { searchTypeKey, searchTemplate, userPermissions, requestOptions } = useAdvancedSearch({
    searchTypeKey: 'search-well-user',
  })

  if (!(searchTemplate && 'authToken' in requestOptions && requestOptions.authToken)) {
    // TODO: Skeleton loading state
    return (
      <ContentContainer>
        <LoadingIndicator>Loading&hellip;</LoadingIndicator>
      </ContentContainer>
    )
  }

  return (
    <ContentContainer>
      <HeadingRow headingText='Users' headingLevel={2}>
        {isAdminUser(user) && (
          <Button icon='new' iconAlignment='left' label='Add new user' path='/admin/users/new/edit' />
        )}
      </HeadingRow>
      <Card isFullWidth>
        <AdvancedSearchTable
          searchTypeKey={searchTypeKey}
          requestOptions={{
            ...requestOptions,
            urlPrefix: `${requestOptions.urlPrefix}/generic-search`,
          }}
          dateFormat={DISPLAY_DATE_FORMAT}
          searchTemplate={searchTemplate}
          pageSize={10}
          currentUserPermissions={userPermissions}
          isTabbedContent={false}
          isShowResultsOnMap={false}
          isShowResultsCard={false}
          defaultSortBy={{
            orderColumn: 'name',
            orderDirection: 'asc',
          }}
          resultsHeading='Users'
          resultNameSingular='user'
          resultNamePlural='users'
        />
      </Card>
    </ContentContainer>
  )
}
